/* 通用流程表单
* 动态注册组件,参考地址: https://cloud.tencent.com/developer/article/2245863?areaSource=102001.10&traceId=1N3xOjf91f9QqcBojxBDC
*/
const modules = import.meta.glob("@/components/FlowForm/*.vue");

const components = {
  install: function (app) {
    for (let path in modules) {
      modules[path]().then((mod) => {
        app.component(mod["default"]["name"], mod["default"]);
      });
    }
  },
};
export default components;

